import createAction from '../../common/services/create-action';

export const OFFLINE_MIGRATION_TRIGGER = 'offline-migration/TRIGGER';

export const triggerOfflineMigration = createAction(OFFLINE_MIGRATION_TRIGGER);
